let pendingArtifact: unknown = null;

export function setPendingArtifact(data: unknown) {
    pendingArtifact = data;
}

export function consumePendingArtifact(): unknown {
    const d = pendingArtifact;
    pendingArtifact = null;
    return d;
}
